'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth from "./presto.types$-Two-Factor-Auth.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuth$() {
}
export { $c_Lpresto_types$TwoFactorAuth$ as $c_Lpresto_types$TwoFactorAuth$ };
$p = $c_Lpresto_types$TwoFactorAuth$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuth$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuth$() {
}
export { $h_Lpresto_types$TwoFactorAuth$ as $h_Lpresto_types$TwoFactorAuth$ };
$h_Lpresto_types$TwoFactorAuth$.prototype = $p;
$p.l = (function() {
  return "TwoFactorAuth";
});
$p.z7 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth.$c_Lpresto_types$TwoFactorAuth($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3), x$0.j(4), x$0.j(5));
});
var $d_Lpresto_types$TwoFactorAuth$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuth$, "presto.types$TwoFactorAuth$", ({
  a2A: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TwoFactorAuth$ as $d_Lpresto_types$TwoFactorAuth$ };
var $n_Lpresto_types$TwoFactorAuth$;
function $m_Lpresto_types$TwoFactorAuth$() {
  if ((!$n_Lpresto_types$TwoFactorAuth$)) {
    $n_Lpresto_types$TwoFactorAuth$ = new $c_Lpresto_types$TwoFactorAuth$();
  }
  return $n_Lpresto_types$TwoFactorAuth$;
}
export { $m_Lpresto_types$TwoFactorAuth$ as $m_Lpresto_types$TwoFactorAuth$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth$.js.map
